import { Box, Button } from '@chakra-ui/react'
import { colors } from '../../../../utilities/colors'
import { useTranslation } from 'react-i18next'

export default function SegmentedPicker({ mode, onChange, accent, kind, hasAuctions, hasMyLocations }) {
  const { t } = useTranslation()
  const prefix = kind === 'origin' ? t('From') : t('To')
  const myLocationsOption = hasMyLocations && { value: 'my', label: t('My Locations') }
  const auctionOption = hasAuctions && { value: 'auction', label: `${prefix} ${t('Auction')}` }
  const manualOption = { value: 'manual', label: t('Other Address') }
  const pickerOptions = (kind === 'origin'
    ? [auctionOption, myLocationsOption, manualOption]
    : [myLocationsOption, auctionOption, manualOption]
  ).filter(Boolean)

  const isSelected = (option) => mode === option.value

  const buttonProps = (opt) => ({
    onClick: () => onChange(opt.value),
    size: 'sm',
    variant: 'outline',
    borderRadius: 'full',
    borderColor: isSelected(opt) ? accent : colors.grey700,
    bg: isSelected(opt) ? `${accent}22` : 'transparent',
    color: isSelected(opt) ? colors.grey100 : colors.grey300,
    fontWeight: isSelected(opt) ? 'semibold' : 'normal',
    minW: 0,
    px: 3,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    _hover: { borderColor: isSelected(opt) ? accent : colors.grey700, color: colors.grey100, cursor: 'pointer' },
  })

  return (
    <Box display="flex" gap={2} w="full">
      {pickerOptions.map((opt) => (
        <Button key={opt.value} flex={1} {...buttonProps(opt)}>
          {opt.label}
        </Button>
      ))}
    </Box>
  )
}
